<template>
<div class="section__wrapper">
  <div class="section__inner">
    <h1>{{ sectionTitle }}</h1>
    <template v-if="sectionDescription">
      <div
        v-if="descriptionFormat === 'html'"
        v-html="sectionDescription"
        class="section-card"
      />
      <div
        v-else
        class="section-card"
      >
        <p>{{ sectionDescription }}</p>
      </div>
    </template>
    <div
      v-if="isLectures"
      class="section-card"
    >
      <h2 class="section-title">Темы лекций</h2>
      <ul>
        <li v-for="lecture of section.lectures"
          :key="lecture.id"
        >
          {{ lecture.title }}
        </li>
      </ul>
    </div>
    <div
      v-if="sectionModerators || sectionSpeakers"
      class="section-card"
    >
      <h3 class="section-title">Модератор</h3>
      <ul class="no-dot">
        <li v-for="moderator of sectionModerators"
          :key="`moder-${moderator.id}`"
        >
          <div class="section-persone__wrapper">
            <div
              class="section-persone__photo"
            >
              <div
                :class="[!moderator.photo ? photoAlter() : '']"
                class="persone-photo"
              >
                <img v-if="moderator.photo" :src="moderator.photo" alt="">
                <div v-else class="no-photo">
                  <span>{{ noPhoto(moderator) }}</span>
                </div>
              </div>
            </div>
            <div class="section-persone">
              <div
                v-if="moderator.name"
                class="section-persone__name"
              >
                {{ moderator.name }}
              </div>
              <div
                v-if="moderator.position"
                class="section-persone__position"
              >
                {{ moderator.position }}
              </div>
              <div
                v-if="moderator.company"
                class="section-persone__company"
              >
                {{ moderator.company }}
              </div>
            </div>
          </div>
        </li>
      </ul>
      <h3 class="section-title">Спикеры</h3>
      <ul class="speakers-list no-dot">
        <li v-for="speaker of sectionSpeakers"
          :key="`speaker-${speaker.id}`"
        >
          <div class="section-persone__wrapper">
            <div
              class="section-persone__photo"
            >
              <div
                :class="[!speaker.photo ? photoAlter() : '']"
                class="persone-photo"
              >
                <img v-if="speaker.photo" :src="speaker.photo" alt="">
                <div v-else class="no-photo">
                  <span>{{ noPhoto(speaker) }}</span>
                </div>
              </div>
            </div>
            <div class="section-persone">
              <div
                v-if="speaker.name"
                class="section-persone__name"
              >
                {{ speaker.name }}
              </div>
              <div
                v-if="speaker.position"
                class="section-persone__position"
              >
                {{ speaker.position }}
              </div>
              <div
                v-if="speaker.company"
                class="section-persone__company"
              >
                {{ speaker.company }}
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
</template>
<script>
import appBaseNav from '@/components/mixins/appBaseNav';
import sections from '@/components/mixins/methodsSections';

export default {
  name: 'SectionPageView',
  mixins: [appBaseNav, sections],
  props: {
    section_id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      section: null,
    };
  },
  computed: {
    sectionTitle() {
      return this.section?.title ? `${this.section?.name} ${this.section?.title}`.trim() : (this.section?.name || 'Детали сессии');
    },
    sectionDescription() {
      return this.section?.description;
    },
    descriptionFormat() {
      return this.section?.description_format || 'text';
    },
    isLectures() {
      return !!this.section?.lectures;
    },
    sectionModerators() {
      return this.section?.moderators;
    },
    sectionSpeakers() {
      return this.section?.speakers;
    },
  },
  watch: {
    locale() {
      this.$store.commit('setPageTitle', this.$t('questionList.header_title'));
    },
  },
  mounted() {
    this.$store.commit('setPageTitle', this.$t('questionList.header_title'));
    this.$emit('loading', true);
    Promise.all([
      this.getSection(this.section_id),
    ])
      .then(([
        section,
      ]) => {
        this.section = { ...section };
        console.log(section);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.$emit('loading', false);
      });
  },
  methods: {
    noPhoto(persone) {
      const [fname, lname] = persone.name.split(' ');
      return `${fname[0]}${lname[0]}`;
    },
    photoAlter() {
      return `alter-photo-${['rose', 'orange', 'blue', 'purpure', 'lilac', 'green'][Math.floor(Math.random() * 6)]}`;
    },
  },
};
</script>
<style lang="scss">
.section {
  &__wrapper {
    h1, h2, h3, p, ul, ol {
      margin: 0;
    }
    ul {
      li {
        &::before {
          content: '';
          display: block;
          border-radius: 50%;
          width: 8px;
          height: 8px;
          background-color: #e62d86;
          margin-left: -16px;
          flex: 0 0 auto;
        }
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        gap: 12px;

        &:last-child {
          margin-bottom: 0;
        }
      }
      padding-left: 20px;

      &.no-dot {
        padding-left: 0;
        li {
          &::before {
            display: none;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.section {
  &__wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: 100%;
    padding: 0 12px;
    gap: 10px;
  }
  &__inner {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 760px;
    min-height: 100%;
    margin: 20px auto;
    gap: 10px;
  }

  &-card {
    padding: 20px;
    border-radius: 20px;
    background-color: #ffffff;
  }

  &-title {
    margin-bottom: 10px;
  }

  &-persone {
    &__wrapper {
      display: flex;
      flex-direction: row;
      gap: 10px;

      .persone-photo {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 50px;
        height: 50px;
        background-color: #ff8844;
        border-radius: 50%;
        margin-top: 6px;
        overflow: hidden;

        &.alter-photo {
          &-rose {
            background: #FF7777;
          }
          &-orange {
            background: #FFAA77;
          }
          &-blue {
            background: #77AAFF;
          }
          &-purpure {
            background: #FF77DD;
          }
          &-lilac {
            background: #8850CC;
          }
          &-green {
            background: #40BB40;
          }
        }
        & > img {
          width: 100%;
        }
        & > .no-photo {
          font-size: 20px;
          line-height: 20px;
          color: #FFFFFF;
        }

      }
    }
    &__name {
      font-weight: 700;
    }
    &__position {
      font-style: italic;
    }
  }

  display: flex;
  flex-direction: column;
  row-gap: 12px;
  padding: 0 12px 12px;
}
.speakers-list {
  li {
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
